// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Dinero from 'dinero.js';

Dinero.defaultCurrency = 'EUR';
Dinero.globalFormat = '$0,0.00';
